import './Home.css';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../components/Icon';

import imgBackground from '../assets/Hometitle_upsense.webp';
import imgAbout from '../assets/upsense_app_mockup.webp';
import imgLogo from '../assets/upsense_logo.svg';
import imgLogoPurple from '../assets/upsense_logo_purple.svg';
import imgSymbol from '../assets/upsense_symbol.svg';
import imgDecorativeVector from '../assets/upsense_vector.svg';

// ── Inline ikony z bottom navu (target / magnifier) ──
const IconTarget = () => (
  <svg width="28" height="28" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 38C13.9252 38 9.15368 36.0237 5.56498 32.435C1.97627 28.8463 0 24.0748 0 19C0 13.9252 1.97627 9.15368 5.56498 5.56498C9.15368 1.97627 13.9244 0 19 0C24.0756 0 28.8463 1.97627 32.435 5.56498C36.0237 9.15368 38 13.9252 38 19C38 24.0748 36.0237 28.8463 32.435 32.435C28.8463 36.0237 24.0748 38 19 38ZM19 5.55131C11.5843 5.55131 5.55131 11.5843 5.55131 19C5.55131 26.4157 11.5843 32.4487 19 32.4487C26.4157 32.4487 32.4487 26.4157 32.4487 19C32.4487 11.5843 26.4157 5.55131 19 5.55131Z" fill="#9616FF"/>
    <path d="M19 28.774C13.611 28.774 9.22632 24.3893 9.22632 19.0003C9.22632 13.6112 13.611 9.22656 19 9.22656C24.3891 9.22656 28.7738 13.6112 28.7738 19.0003C28.7738 24.3893 24.3891 28.774 19 28.774ZM19 14.7779C16.6719 14.7779 14.7776 16.6722 14.7776 19.0003C14.7776 21.3284 16.6719 23.2227 19 23.2227C21.3282 23.2227 23.2225 21.3284 23.2225 19.0003C23.2225 16.6722 21.3282 14.7779 19 14.7779Z" fill="#9616FF"/>
  </svg>
);
const IconSearch = () => (
  <svg width="26" height="26" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M36 33.1107L26.6795 23.7298C28.5011 21.2551 29.5804 18.195 29.5804 14.8861C29.5804 6.67782 22.9456 0 14.7902 0C6.63479 0 0 6.67866 0 14.887C0 23.0953 6.63479 29.7731 14.7902 29.7731C17.6869 29.7731 20.3902 28.9304 22.6741 27.4761L32.1366 37L36 33.1116V33.1107ZM5.46384 14.887C5.46384 9.71088 9.64747 5.50013 14.7902 5.50013C19.9329 5.50013 24.1166 9.71088 24.1166 14.887C24.1166 20.0631 19.9329 24.2738 14.7902 24.2738C9.64747 24.2738 5.46384 20.0631 5.46384 14.887Z" fill="#9616FF"/>
  </svg>
);

// Dočasne skryté spolu so sekciou „Ako to funguje" — znovu zapnúť spolu s ňou
// const STEPS = [
//   { icon: <Icon name="user" className="ic--lg" />, title: 'Vytvor si profil', text: 'Registrácia trvá len 2 minúty. Pridaj fotky, vyplň krátky dotazník o sebe a o tom, koho hľadáš.' },
//   { icon: <Icon name="infinity" className="ic--lg" />, title: 'Objavuj ľudí', text: 'Prepni na klasické listovanie (swipe) v sekcii Objavuj alebo si prezeraj profily v zozname vlastným tempom v sekcii Hľadaj.' },
//   { icon: <Icon name="message" className="ic--lg" />, title: 'Začni spoznávať', text: 'Keď nájdete vzájomnú zhodu (match), otvorí sa chat a môžete sa začať spoznávať.' },
// ];

const AUDIENCE = [
  { title: 'Pre osamelých 18+', text: 'Pre dospelých, ktorí hľadajú vzťah, partnera, priateľov alebo niekoho na čet.' },
  { title: 'Pre Bratislavu a okolie. Zatiaľ!', text: 'Beta verziou začíname v hlavnom meste a čoskoro sa rozšírime na celé Slovensko.' },
  { title: 'Pre tých, ktorým záleží na súkromí', text: 'Bezpečná platforma s overovaním profilov a prísnou kontrolou údajov.' },
];

const FEATURES: Array<{ icon: React.ReactNode; title: string; text: string; highlight?: boolean }> = [
  { icon: <IconTarget />, title: 'Objavuj', text: 'Rýchle listovanie profilov s pokročilými filtrami.' },
  { icon: <IconSearch />, title: 'Hľadaj', text: 'Prezeranie profilov v prehľadnom katalógu s filtrami podľa veku, mesta a záujmov.' },
  { icon: <Icon name="message" className="ic--lg" />, title: 'Čet v reálnom čase', text: 'Rýchle správy s potvrdením o prečítaní a online statusom.' },
  { icon: <Icon name="verify" className="ic--lg" />, title: 'Overenie profilu', text: 'Overenie pomocou selfie, ktoré ťa ochráni pred falošnými účtami.' },
  { icon: <img src={imgSymbol} alt="" aria-hidden className="home-feature-symbol" />, title: 'Upsense Plus', text: 'Neobmedzené lajky, kto si pozrel tvoj profil, bonusové kredity, štatistika profilu a prioritné zobrazenie.', highlight: true },
  { icon: <Icon name="infinity" className="ic--lg" />, title: 'Neobmedzené lajky', text: 'S Upsense Plus swipuj a lajkuj koľko chceš.' },
  { icon: <Icon name="eye" className="ic--lg" />, title: 'Kto si ťa pozrel', text: 'Zisti kto si pozrel tvoj profil s Upsense Plus.' },
  { icon: <Icon name="day-profile" className="ic--lg" />, title: 'Profil dňa basic / premium', text: 'Možnosť zviditeľniť sa pre používateľov v tvojej oblasti.' },
];

const FAQ = [
  { q: 'Je Upsense naozaj zadarmo?', a: 'Áno. Všetky základné funkcie (registrácia, listovanie profilov, čet so zhodami) sú zadarmo navždy. Pre pokročilé funkcie ponúkame voliteľné predplatné Upsense Plus za 5,99 €/mesiac alebo za predplatené kredity.' },
  { q: 'Pre koho je Upsense určený?', a: 'Pre dospelých od 18 rokov, ktorí hľadajú partnera, vzťah, priateľov alebo niekoho na čet. Bez ohľadu na vek, orientáciu alebo zámery — Upsense rešpektuje rôznorodosť.' },
  { q: 'Ako Upsense chráni moje údaje?', a: 'Servery máme v EÚ, heslá sú šifrované cez bcrypt a všetka komunikácia prebieha cez HTTPS. Sme plne v súlade s GDPR — údaje môžeš kedykoľvek exportovať alebo zmazať účet.' },
  { q: 'Ako prebieha overenie profilu?', a: 'Voliteľne si môžeš overiť identitu nahraním selfie. Po overení získaš odznak pri mene a ostatní užívatelia ti viac dôverujú.' },
  { q: 'Môžem si kedykoľvek zmazať účet?', a: 'Áno, v Nastavenia → Účet → Zmazať profil. Údaje sa trvalo vymažú po 30 dňoch (doba odkladu na obnovu).' },
  { q: 'Ako sa chrániť pred falošnými profilmi?', a: 'Používaj funkcie Blokovať a Nahlásiť na profile podozrivého užívateľa. Každé nahlásenie manuálne rieši náš tím. Odporúčame komunikovať najmä s overenými profilmi.' },
  { q: 'Prečo je aplikácia momentálne len pre Bratislavu a okolie?', a: 'Aby sme ti zabezpečili čo najlepší zážitok a dostatok reálnych profilov v tvojom okolí, beta verziu spúšťame najskôr v Bratislave a okolí. Ak si z iného mesta nevadí, pridaj sa na waitlist a hneď ako rozšírime oblasť dostaneš pozvánku. Postupne ako aplikáciu spoločne vyladíme, otvoríme ju pre celé Slovensko!' },
  { q: 'Čo ak mám problém, otázku alebo podnet na zlepšenie?', a: 'Napíš nám na podpora@upsense.sk alebo cez formulár priamo v aplikácii (Nastavenia → Podpora). Radi pomôžeme.' },
];

export function Home() {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <div className="home-wrapper">
      {/* ── HERO ── */}
      <section className="home-hero">
        <img className="home-bg" src={imgBackground} alt="" aria-hidden width="1920" height="1366" fetchPriority="high" />
        <div className="home-overlay" />
        <img className="home-vector" src={imgDecorativeVector} alt="" aria-hidden />

        <div className="home-logo">
          <img src={imgLogo} alt="upsense logo" />
        </div>

        <div className="home-content">
          <h1 className="home-headline">
            <span className="home-headline-accent">Spoznaj niekoho,</span>
            {' '}
            <br />
            s&nbsp;kým to začne dávať zmysel.
          </h1>

          <p className="home-subtitle"><strong>Čoskoro štartujeme betu pre Bratislavu a okolie!</strong><br />Zapíš sa na waitlist, pomôž nám s testovaním a získaj 2&nbsp;mesiace <strong>Upsense Plus zadarmo + 50 kreditov.</strong></p>
         
          <button className="home-btn-register" onClick={() => navigate('/waitlist')}>
            Pridať sa na waitlist
          </button>

          <p className="home-subtitle"><strong>Si z&nbsp;iného mesta?</strong> Zanechaj nám svoj e-mail a&nbsp;pošleme ti pozvánku hneď ako rozšírime oblasť.</p>
        </div>

        {/*<p className="home-disclaimer">
          Registráciou vyjadrujete súhlas s&nbsp;našimi{' '}
          <a href="/terms" className="home-disclaimer-link">obchodnými podmienkami</a>
          {' '}a&nbsp;<a href="/privacy" className="home-disclaimer-link">zásadami ochrany osobných údajov</a>.
        </p>*/}
      </section>

      {/* ── O UPSENSE ── */}
      <section className="home-section home-about">
        <div className="home-about-text">
          <p className="home-eyebrow">O Upsense</p>
          <h2 className="home-h2">Moderné zoznamovanie štartuje betou v Bratislave a blízkom okolí.</h2>
          <p className="home-paragraph">
            <strong>Pridaj sa na waitlist, získaj prístup medzi prvými a pomôž nám vyladiť aplikáciu. Ak si z iného mesta možeš sa pridať na waitlist a pozvánku dostaneš ked rozšírime oblasť.</strong><br />
            Upsense je nová slovenská zoznamovacia aplikácia navrhnutá s dôrazom na dostupnosť a jednoduchosť. Vytvorili sme ju pre ľudí, ktorí hľadajú skutočné spojenia - či už ide o vážny vzťah, nové priateľstvo alebo len zaujímavú konverzáciu. Bez drahých predplatných a bez kompromisov v oblasti súkromia.
          </p>
          
        </div>
        <div className="home-about-img">
          <img src={imgAbout} alt="Upsense aplikácia na mobile" loading="lazy" width="1000" height="800" />
        </div>
      </section>

      {/* ── AKO TO FUNGUJE ── */}

      {/*
      <section className="home-section home-steps">
        <div className="home-steps-grid">
          <div className="home-steps-head">
            <p className="home-eyebrow">Ako to funguje</p>
            <h2 className="home-h2">Začni v troch jednoduchých krokoch</h2>
            
          </div>
          {STEPS.map((s, i) => (
            <div key={i} className="home-step-card">
              <span className="home-step-icon">{s.icon}</span>
              <h3 className="home-card-title">{s.title}</h3>
              <p className="home-card-text">{s.text}</p>
            </div>
          ))}
        </div>
      </section>
      */}

      {/* ── PRE KOHO ── */}
      <section className="home-section home-audience">
        <p className="home-eyebrow">Pre koho</p>
        <h2 className="home-h2">Pre koho je Upsense?</h2>
        <div className="home-audience-grid">
          {AUDIENCE.map((a, i) => (
            <div key={i} className="home-audience-card">
              <img src={imgSymbol} alt="" aria-hidden className="home-audience-symbol" />
              <div className="home-audience-body">
                <h3 className="home-card-title home-card-title--light">{a.title}</h3>
                <p className="home-card-text home-card-text--light">{a.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── FUNKCIE ── */}
      <section className="home-section home-features">
        <p className="home-eyebrow">Funkcie</p>
        <h2 className="home-h2">Všetko čo na zoznamovanie potrebuješ</h2>
        <div className="home-features-grid">
          {FEATURES.map((f, i) => (
            <div key={i} className={`home-feature-card${f.highlight ? ' home-feature-card--highlight' : ''}`}>
              <span className="home-feature-icon">{f.icon}</span>
              <h3 className={`home-card-title${f.highlight ? ' home-card-title--light' : ''}`}>{f.title}</h3>
              <p className={`home-card-text${f.highlight ? ' home-card-text--light' : ''}`}>{f.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── MID CTA ── */}
      <section className="home-section home-midcta">
        <h3 className="home-h3 home-midcta-title">Pripravený niekoho spoznať?</h3>
        <button className="home-btn-register-cta" onClick={() => navigate('/waitlist')}>Pridať sa na waitlist</button>
      </section>

      {/* ── CENNÍK ── */}
      <section className="home-section home-pricing">
        <p className="home-eyebrow home-eyebrow--light">Cenník</p>
        <h2 className="home-h2 home-h2--light">Bez predražených predplatných</h2>
        <div className="home-pricing-grid">
          {/* Zadarmo */}
          <div className="home-price-card">
            <p className="home-price-label">Zadarmo</p>
            <p className="home-price-amount">0 €</p>
            <ul className="home-price-list">
              <li>Neobmedzené prezeranie profilov</li>
              <li>25 lajkov denne</li>
              <li>5 prvých správ mesačne</li>
              <li>Rozšírené filtrovanie</li>
              <li>Čet so zhodami (matchmi)</li>
              <li>Možnosť používania kreditov</li>
            </ul>
          </div>

          {/* Plus */}
          <div className="home-price-card home-price-card--plus">
            <p className="home-price-label">Upsense Plus</p>
            <p className="home-price-amount">5,99 € <span>/ mesiac</span></p>
            <ul className="home-price-list">
              <li>Neobmedzené lajky</li>
              <li>Kto si ťa pozrel</li>
              <li>Prioritné zobrazenie</li>
              <li>60 prvých správ mesačne</li>
              <li>10× denne obnovenie pass</li>
              <li>Štatistika profilu</li>
              <li>Skrytý režim (inkognito)</li>
              <li>10 kreditov / 5 kr pri ďalšom predĺžení</li>
            </ul>
            <p className="home-price-yearly">Ročná platba — 59,99 €<br /><span>Bonus: 2 mesiace zdarma + 30 kreditov</span></p>
          </div>

          {/* Kredity */}
          <div className="home-price-card">
            <p className="home-price-label">Kredity</p>
            <p className="home-price-amount">od 1,99 €</p>
            <ul className="home-price-list">
              <li>Boost profilu — 3 kr</li>
              <li>Profil dňa Basic / Premium — 10/25 kr</li>
              <li>Super záujem — 1 kr</li>
              <li>Obnoviť pass — 2 kr</li>
            </ul>
            <div className="home-credit-packs">
              <div className="home-credit-pack"><Icon name="credits" className="ic--sm" /> 10<span>1,99 €</span></div>
              <div className="home-credit-pack"><Icon name="credits" className="ic--sm" /> 50<span>7,99 €</span></div>
              <div className="home-credit-pack"><Icon name="credits" className="ic--sm" /> 100<span>14,99 €</span></div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="home-section home-faq">
        <p className="home-eyebrow">FAQ</p>
        <h2 className="home-h2">Často kladené otázky</h2>
        <div className="home-faq-list">
          {FAQ.map((item, i) => (
            <div key={i} className="home-faq-item">
              <button className={`home-faq-q${openFaq === i ? ' home-faq-q--open' : ''}`} onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                <span>{item.q}</span>
                <span className="home-faq-chevron">{openFaq === i ? '−' : '+'}</span>
              </button>
              {openFaq === i && <div className="home-faq-a">{item.a}</div>}
            </div>
          ))}
        </div>
      </section>

      {/* ── FINÁLNE CTA ── */}
      <section className="home-section home-finalcta">
        <img className="home-vector home-vector--final" src={imgDecorativeVector} alt="" aria-hidden />
        <h2 className="home-h2-footer home-h2--light">Pripravený spoznať niekoho nového?</h2>
        <p className="home-finalcta-sub">Pridaj sa na waitlist a buď medzi prvými.</p>
        <div className="home-finalcta-btns">
          <button className="home-btn-register-footer" onClick={() => navigate('/waitlist')}>Pridať sa na waitlist</button>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="home-footer">
        <img src={imgLogoPurple} alt="upsense" className="home-footer-logo" />
        <nav className="home-footer-nav">
          <a href="/terms">Obchodné podmienky</a>
          <span>·</span>
          <a href="/privacy">Súkromie</a>
          <span>·</span>
          <a href="/cookies">Cookies</a>
        </nav>
        <p className="home-footer-copy">© 2026 upsense.sk · Všetky práva vyhradené · bunka s.r.o.</p>
      </footer>
    </div>
  );
}
